import React from 'react';
import { Wrapper, Container } from './style';
import { post } from '../../utils/request';
import { Toast } from 'antd-mobile';
import CountUp from "react-countup";
import Config from '../../config';
import moment from 'moment';

class Detail extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      obj: {},
      list: [],
    }
  }
  async componentDidMount() {
    document.title = '交易明细'
    this.loadDetail()
  }
  async loadDetail(){
    let params = {page: 1,pageSize: 0}
    Toast.loading('', 10)
    let res = await post(`/pgy/user/${Config.appId}/incomeList`, params)
    Toast.hide()
    this.setState({obj: res.data.data,list: res.data.data.records})
  }
  render() {
    let { obj,list } = this.state;
    return (
      <Wrapper>
        <Container>
          <div className="topFixed">
            <div className="bg">
              <p><CountUp start={0} end={obj.balance} duration="1" decimals="2" className="red" /></p>
              <b>账户余额(元)</b>
            </div>
            <div className="navs">
              <div className="nums num1">
                <div className="item">
                  <CountUp start={0} end={obj.totalIncome} duration="1" decimals="2" className="red" />
                  <b>累积收益(元)</b>
                </div>
              </div>
              <div className="nums num2">
                <div className="item">
                  <CountUp start={0} end={obj.withdrawal} duration="1" decimals="2" />
                  <b>已提现(元)</b>
                </div>
              </div>
            </div>
            <div className="title">交易流水</div>
          </div>
          <div className="lists">
            <div className="list">
              {list.map((v, i) => (
                <div className="item" key={`key-list-${i}`}>
                  <div className="left">
                    {v.tradeType==1&&(<p className="p2">蒲公英奖金</p>)}
                    {v.tradeType==2&&(<p className="p2">辅导成长奖</p>)}
                    {v.tradeType==3&&(<p className="p2">提现</p>)}
                    <span>{moment(Number(`${v.createTime}000`)).format('YYYY-MM-DD hh-mm-ss')}</span>
                  </div>
                  <div className="center">
                    {v.tradeType==1&&(<><p>{v.inviteCustomerInfo.customerName} 签约成功</p><span>由你邀请</span></>)}
                    {v.tradeType==2&&(<><p>{v.inviteCustomerInfo.customerName} 签约成功</p><span>由{v.customerParentInfo.customerName}邀请</span></>)}
                    {(v.tradeType==3&&v.paymentType==2)&&(<><p>支付宝转账</p><span>{v.accountNo}</span></>)}
                    {(v.tradeType==3&&v.paymentType==1)&&(<><p>银行卡转账</p><span>{v.bankBranchName} {v.accountNo}</span></>)}      
                  </div>
                  {(v.tradeType==1||v.tradeType==2)&&(<div className="right"><p>+</p><b>￥</b><span>{v.amounts}</span></div>)}
                  {v.tradeType==3&&(<div className="right red"><p>-</p><b>￥</b><span>{v.amounts}</span></div>)}
                </div>
              ))}
              <div className="tips">
                {list.length==0&&(<p>暂无数据</p>)}
                {list.length!=0&&(<p>加载完成</p>)}
              </div>
            </div>    
          </div>
        </Container>
      </Wrapper>
    );
  }
}
export default Detail;